// Lightweight sound effects via Web Audio API (no external files) + haptics.
let ctx = null;

function getCtx() {
  if (typeof window === "undefined") return null;
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  return ctx;
}

// Call on a user gesture (e.g. clicking "Iniciar") to unlock audio on the presenter.
export function ensureAudio() {
  const c = getCtx();
  if (c && c.state === "suspended") c.resume().catch(() => {});
}

function tone(freq, start, dur, type = "triangle", gain = 0.22) {
  const c = getCtx();
  if (!c) return;
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.value = freq;
  o.connect(g);
  g.connect(c.destination);
  const t = c.currentTime + start;
  g.gain.setValueAtTime(0.0001, t);
  g.gain.exponentialRampToValueAtTime(gain, t + 0.02);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.start(t);
  o.stop(t + dur + 0.05);
}

export function buzz(pattern) {
  try {
    if (typeof navigator !== "undefined" && navigator.vibrate) navigator.vibrate(pattern);
  } catch {
    /* ignore */
  }
}

// Reveal sting: quick two-note chime.
export function playReveal() {  ensureAudio();
  tone(659.25, 0, 0.16, "triangle", 0.24);
  tone(987.77, 0.11, 0.26, "triangle", 0.24);
  buzz([45]);
}

// Ranking turn: ascending fanfare + sparkle.
export function playRanking() {
  ensureAudio();
  const notes = [523.25, 659.25, 783.99, 1046.5];
  notes.forEach((f, i) => tone(f, i * 0.13, 0.32, "triangle", 0.2));
  tone(1318.51, 0.55, 0.45, "sine", 0.18);
  buzz([30, 50, 30, 50, 80]);
}

// Countdown tick (3, 2, 1).
export function playTick() {
  ensureAudio();
  tone(440, 0, 0.14, "square", 0.16);
  buzz([25]);
}

// "GO!" — brighter chord to kick off the quiz.
export function playGo() {
  ensureAudio();
  tone(659.25, 0, 0.22, "triangle", 0.22);
  tone(880, 0, 0.24, "triangle", 0.18);
  tone(1174.66, 0.05, 0.3, "sine", 0.18);
  buzz([60, 40, 90]);
}
